<template>
  <base-section id="pro-features">
    <v-img
      :src="require('@/assets/Gryphon-Line-Art.svg')"
      class="mx-auto mb-8"
      max-width="128"
    />
    <base-section-heading title="Apps & API's">
      Results returning a <strong>Pass or Fail</strong> for my various apps and
      api's.
    </base-section-heading>
    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="7"
        >
          <v-simple-table>
            <thead>
              <tr>
                <th />
                <th class="text-body-1 font-weight-bold text-center">
                  Pingable?
                </th>
                <th class="text-body-1 font-weight-bold text-center">
                  Overall Health?
                </th>
              </tr>
            </thead>

            <tbody class="text-body-1">
              <tr
                v-for="([name, one, two], i) in features"
                :key="i"
              >
                <td v-text="name" />

                <td class="text-center font-weight-bold">
                  <template v-if="typeof one === 'boolean'">
                    <v-icon :color="one ? 'success' : 'error'">
                      mdi-{{ one ? "check" : "close" }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ one }}
                  </template>
                </td>

                <td class="text-center font-weight-bold">
                  <template v-if="typeof two === 'boolean'">
                    <v-icon :color="two ? 'success' : 'error'">
                      mdi-{{ two ? "check" : "close" }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ two }}
                  </template>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProChart',

    data: () => ({
      features: [
        // ['wonderouswall.com', true, true],
        ['reviewthisphoto.com', false, false],
        // ['trumpyquotes.com', true, true],
        ['thelistnight.com', false, false],
        ['newscomparer.com', false, false],
        // ['yourdamnmusic.com', false, true],
        ['lightningforest.com', true, true],
      ],
    }),
  }
</script>
